import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProjectsPromotionsAddFileComponent } from '../projects-promotions-add-file/projects-promotions-add-file.component';
import { ProjectsService } from 'src/app/services/projects.service';
import { MainService } from 'src/app/services/main.service';
import Swal from 'sweetalert2';
import { ProjectModel } from 'src/app/models/project.model';
import { PromotionsFileEditComponent } from '../promotions-file-edit/promotions-file-edit.component';
import { PromotionsConfigurationComponent } from '../promotions-configuration/promotions-configuration.component';
import { UsersService } from 'src/app/services/users.service';
 
@Component({
  selector: 'app-projects-promotions-add',
  templateUrl: './projects-promotions-add.component.html',
  styleUrls: ['./projects-promotions-add.component.scss']
})
export class ProjectsPromotionsAddComponent implements OnInit {
  project: any;
  isLoading = true;
  promotionFiles: any;
  selected_columns: Array<number> = [];
  promotionFile: any = [];
  displayedColumns: string[] = [];
  selectedColumns: string[] = [];
  tieneColGuardadas: boolean = true;
  id_camp :  number = 0;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    private projectService : ProjectsService,
    private main : MainService,
    private matDialog: MatDialog,
    private dialogRef: MatDialogRef<ProjectsPromotionsAddComponent>,
    private userService : UsersService
  ) {
    this.project = this.data.project;
    this.id_camp = this.data.id_camp;
    console.log("proyecto", this.project);
    this.loadData();
   }

  ngOnInit(): void {
  }

  loadData(){
     this.main.ShowLoading();
    this.projectService.getPromotionFiles(this.project.id).subscribe(
      (result:any) => {
         this.main.HideLoading();
       this.promotionFiles = result.data;
       //this.loadColumns(this.project.id);
       //this.loadColumnsByUser(this.project.id);
      },
      (err:any) => {
        this.isLoading = false;
      if(err.error.message != "No valid art files were found in the request")
      {
        Swal.fire({
          icon: 'error',
          title: 'Error al obtener registros',
          text: 'Ocurrió un error al obtener los registros.'
        });
      }
      }
    );
  }

  openDialogPromoEdit(){
      this.matDialog.open(PromotionsFileEditComponent, {
      panelClass: ['dialogs-xxl'],
      data: {
        project: this.project,
        id_camp : this.id_camp
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp?.reload) {
          this.loadData();
        }
      }
    );
  }

  openDialogUploadDistFile() {
    this.matDialog.open(ProjectsPromotionsAddFileComponent, {
      panelClass: ['dialogs-main'],
      data: {
        project: this.project
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp?.reload) {
          this.loadData();
        }
      }
    );
  }

  openConfig(){
     this.main.ShowLoading();
       this.matDialog.open(PromotionsConfigurationComponent, {
         panelClass: ['dialogs-md'],
         data: {
           id_file: this.promotionFiles[0].id,
           id_proj : this.id_camp
         }
       }).afterClosed().subscribe(
         resp => {
          this.loadData();
         }
       );
    }

  hasPermissions(key : string, buho : boolean|any, client : boolean|any):  boolean {
    return this.userService.hasPermissions(key, buho, client);
  }


}
